import React, { useState } from "react"
import styled from "styled-components"
import { Collapse } from "react-collapse"
import { offer } from "../../data/offer"

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0;
  & h3 {
    color: #fff;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 1px;
    font-family: "Made Bold", sans-serif;
    margin: 0 0 0 12px;
  }
  @media (min-width: 1024px) {
    padding: 12px 0;
    & h3 {
      margin: 0 0 0 16px;
    }
  }
`

export const StyledButton = styled.button`
  min-width: 30px;
  height: 30px;
  border: 2px solid #474dc4;
  border-radius: 50%;
  position: relative;
  outline: 0;
  & span:first-child {
    width: 2px;
    height: 14px;
    background-color: #474dc4;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: 0.2s ease;
  }
  & span:last-child {
    width: 14px;
    height: 2px;
    background-color: #474dc4;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &.active {
    & span:first-child {
      opacity: 0;
    }
  }
`

const StyledSection = styled.section`
  background-color: #000;
  .ReactCollapse--collapse {
    transition: height 0.2s ease;
    margin-bottom: 8px;
  }
  .ReactCollapse--content p {
    color: #fff;
    padding-left: 25px;
    margin-left: 14px;
    border-left: 2px solid #474dc4;
    @media (min-width: 1024px) {
      width: 75%;
      padding-left: 30px;
      font-size: 20px;
      line-height: 32px;
    }
  }
`

const CollapsedOffer = () => {
  const [activeCard, setActiveCard] = useState(0)
  return (
    <StyledSection>
      {offer.map(({ description, title }, i) => (
        <React.Fragment key={title}>
          <Container onClick={() => setActiveCard(i)}>
            <StyledButton
              type="button"
              className={i === activeCard && "active"}
              aria-label="More"
            >
              <span />
              <span />
            </StyledButton>
            <h3>{title}</h3>
          </Container>
          <Collapse isOpened={i === activeCard}>
            <p>{description}</p>
          </Collapse>
        </React.Fragment>
      ))}
    </StyledSection>
  )
}

export default CollapsedOffer
